import React, { Component } from "react";
import { Link } from "react-router-dom";
import Content from "./Content";
import Notes from "./Notes";
export default class LMSPageInfo extends Component {
  render() {
    return (
      <div>
        <div className="py-3">
          <div className="container border shadow-sm p-0 bg-white">
            <div className="header bg-primary text-white">
              <div className="row m-0">
                <div className="col-md-6 p-3 d-flex align-items-center">
                  <h5 className="m-0">
                    <Link to="/admin/dashboard">Home</Link> /{" "}
                    <Link to="/admin/courses">Courses</Link> /{" "}
                  </h5>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <Content />
                <Notes
                  text="Each Instructor that wants to create an online session with
                    Zoom has to connect his account with LiveLMS by creating
                    first the app, to get the Client ID and Client Secret,
                    exactly as described above."
                />
                <Notes
                  text="To comply with Zoom’s security initiative, we’ve added a
                    password feature. Now, all webinars will require a password
                    for users to join."
                />
                <p>
                  <strong>
                    Conferences
                    <br />
                  </strong>
                  When an instructor creates a conference they need to enter the
                  desired <strong>password</strong> <strong>(1)</strong> in the
                  dedicated field.
                  <br />
                  <br />
                  <img
                    src="https://help.talentlms.com/hc/article_attachments/360012651380/conferences__13_.png"
                    alt="conferences__13_.png"
                  />
                </p>
                <p>
                  <strong>Instructor-Led Training sessions</strong>
                  <br />
                  For instructor-led training sessions, the password populates
                  automatically when the instructor creates the webinar.
                  Learners can <strong>view (2)</strong> and use the password
                  right before joining the session. <br />
                  <br />
                  <img
                    src="https://help.talentlms.com/hc/article_attachments/360012651640/ILT_view.png"
                    alt="ILT_view.png"
                  />
                </p>
                <p>
                  <strong>You did it!</strong>
                </p>
                <p>
                  <span>
                    You're now ready to create your first Zoom-enabled video
                    conference.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
